// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__36ZJm","label":"Completed_label__3L-Km"};